import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import {PARTNER_BRAND_TAB_LABELS, PartnerBrandTab} from "./PartnerBrandSections";

interface Props {
	/**
	 * Tabs whose changes would be lost.
	 */
	dirtyTabs: PartnerBrandTab[];
	onStay: () => void;
	onLeave: () => void;
}

/**
 * Asks before leaving the page with unsaved changes.
 */
const UnsavedChangesModal = (props: Props) =>
	<Modal customClass={"c-pb-unsaved-modal"} onCloseClicked={props.onStay} title={"Leave without saving?"} autoWidth={true}>
		<p className={"c-pb-unsaved-modal_text"}>
			{`Your changes in ${props.dirtyTabs.map(tab => PARTNER_BRAND_TAB_LABELS[tab]).join(", ")} will be lost.`}
		</p>
		<div className={"c-pb-unsaved-modal_buttons"}>
			<ButtonSecondary label={"Stay"} onClick={props.onStay}/>
			<ButtonPrimary label={"Leave"} onClick={props.onLeave}/>
		</div>
	</Modal>;

export default UnsavedChangesModal;
